import { BrowserUtil } from '../BrowserUtil';
import { getBaseComDomain } from '../AppConfigUtil';
export const getServerHost = () => {
    const origin = BrowserUtil.getOrigin();
    if (origin === '//localhost:9021' || origin === '//localhost:3000') {
        return '//localhost:9020';
    }
    if (origin.includes('.local.') || origin.includes('localhost')) {
        if (BrowserUtil.isSsl()) {
            return 'https://web.local.aperza.com:9020';
        }
        return 'https://web.local.aperza.com:9020';
    }
    if (origin.includes('storybook.')) {
        return 'https://web.test.aperza.com';
    }
    return `https://web${getBaseComDomain()}`;
};
